import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonSpinner from "../../../../../components/Buttons/ButtonSpinner";
import { updatePackage } from "../../../../../utils/services/portalBoticario";

export const ModalEditPackage = ({
  isOpen,
  toggle,
  jwt,
  refetch,
  packageData,
}) => {
  const [formData, setFormData] = useState({
    description: "",
    code: "",
    available: 1,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  useEffect(() => {
    if (packageData) {
      setFormData({
        description: packageData.description || "",
        code: packageData.code || "",
        available: packageData.available || 1,
      });
    }
  }, [packageData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "code" ? value.toUpperCase().replace(/\s+/g, "") : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!formData.description.trim())
      validationErrors.description = "Campo obrigatório";
    if (!formData.available) validationErrors.available = "Campo obrigatório";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    const updatedData = {
      description: formData.description.trim(),
      code: formData.code.trim(),
      available: Number(formData.available),
    };

    try {
      const response = await updatePackage(packageData.id, updatedData, jwt);

      if (response) {
        refetch();
        setIsShowSuccess(true);
      }
    } catch (error) {
      const { data } = error.response || {};
      setErrors({
        api: data?.message || "Erro ao atualizar o pacote.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} centered autoFocus>
      <ModalHeader toggle={toggle}>Editar Pacote</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">Descrição *</label>
              <input
                className="form-control"
                type="text"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
              {errors.description && (
                <small className="text-danger">{errors.description}</small>
              )}
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">Código *</label>
              <input
                className="form-control"
                type="text"
                name="code"
                value={formData.code}
              />
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">Disponível *</label>
              <input
                className="form-control"
                type="number"
                name="available"
                value={formData.available}
                onChange={handleChange}
              />
              {errors.available && (
                <small className="text-danger">{errors.available}</small>
              )}
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Button
                color="danger"
                style={{ width: 80 }}
                onClick={toggle}
                disabled={isLoading}
              >
                Fechar
              </Button>
              <ButtonSpinner
                title="Salvar"
                type="submit"
                isLoading={isLoading}
                action="U"
                marginLeft={10}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>

      {isShowSuccess && (
        <SweetAlert
          title="Atualizado"
          success
          onConfirm={() => {
            setIsShowSuccess(false);
            toggle();
          }}
        >
          Pacote atualizado com sucesso!
        </SweetAlert>
      )}
    </Modal>
  );
};
